import { useShallow } from 'zustand/shallow'

import { useStore, getObjectPage } from '@app/store'
import type { BoundedState } from '@app/store/types'

const useGetObjectPage = <T extends keyof BoundedState['page']>(type: T): ReturnType<typeof getObjectPage<T>> =>
  useStore(useShallow((state) => getObjectPage(state, type)))

export default useGetObjectPage
